namespace TR {

    interface ValidationMessageScope extends ng.IScope {
        vs :ValidationMessage;
    }
    interface ValidationMessageModel extends ng.INgModelController {
        ValidationSummary :{ Focused :boolean, PreviouslyFocused :boolean};
    }

    class FormField {
        private Field :ValidationMessageModel;
        private Children :ValidationMessageModel[] = [];
        private Inputs : JQuery[] = [];

        constructor(field: ng.INgModelController) {
            this.Field = FormField.addValidationObjectToField(field);
        }

        public addChildField(input: JQuery, field: ng.INgModelController) :void {
            this.addInputField(input);
            this.Children.push(FormField.addValidationObjectToField(field));
        }

        public addInputField(input: JQuery) :void {
            this.Inputs.push(input);
        }

        public errorMessages() :{} {
            return this.isValid() ? {} : this.Field.$error;
        }

        public getInputFields() :JQuery[] {
            return this.Inputs;
        }

        public isFocused() :boolean {
            return this.Children.length > 0 ?
                _.some(this.Children, (f) => f.ValidationSummary.Focused === true)
                : this.Field.ValidationSummary.Focused;
        }

        public isValid() :boolean {
            return !this.Field.$invalid;
        }

        public wasPreviouslyFocused() :boolean {
            return this.Children.length > 0 ?
                _.every(this.Children, (f) => f.ValidationSummary.PreviouslyFocused === true)
                : this.Field.ValidationSummary.PreviouslyFocused;
        }

        private static addValidationObjectToField(field: ng.INgModelController) :ValidationMessageModel{
            let f = field as ValidationMessageModel;
            f.ValidationSummary = {
                Focused: false,
                PreviouslyFocused: false
            };
            return f;
        }
    }

    class ValidationMessage {

        private fieldNames :string;
        private fields :FormField[] = [];
        private form :ng.IFormController;
        private readonly labels :string[] = [];
        private labelStrings :string;
        private readonly map :any;
        private msgMap :string | null;
        private rootForm :ng.IFormController;
        private watchers :{() :void}[] = [];

        public active :boolean;
        public invalid :boolean;
        public errorMessages :string[] = [];
        private alwaysWatchFields :string;

        constructor(private $scope :ValidationMessageScope,
                    private $timeout :ng.ITimeoutService,
                    private validationService :any) {

            for (let l of this.labelStrings.split('|')) {
                this.labels.push(l);
            }

            this.map = this.msgMap == null ? {} : JSON.parse(this.msgMap);
        }

        init(form :ng.IFormController, formElement :JQuery) :void {

            this.form = form;

            for (let name of this.fieldNames.split('|')) {
                var f = this.form[name];
                let formField = new FormField(this.form[name]);
                //find the input DOM element within our form and attach some handlers
                //use the name property to associate the field and input also keep a
                //pointer to the input field as we will want to add/remove css classes
                //depending on its validity
                const input = formElement.find(`[name='${name}']`).first();
                if (input.is('select') || input.is('input')) {
                    input
                        .focus((e) => this.focusHandler(e))
                        .blur((e) => this.blurHandler(e));
                    formField.addInputField(input);
                } else {
                    //find our actual sub inputs and add a Validation summary to these
                    _.each(input.find('select,input')
                            , (ele :JQuery) => formField.addChildField($(ele), this.form[ele.name])
                    );

                    input
                        .focusin((e) => this.focusHandler(e))
                        .focusout((e) => this.blurHandler(e));
                }

                this.fields.push(formField);
            }

            //this is a bit of a hack to solve issues where we have external influences on a field.
            //we should avoid having so many watches
            if (this.alwaysWatch()) {
                _.each(this.fields, (f,i) => {
                    this.watchers.push(
                        this.$scope.$watch(`vm.fields[${i}].isValid()`, (n, o) => {
                            if (n !== o) {
                                this.active = _.every(this.fields, (f) => f.wasPreviouslyFocused() === true)
                                                            || _.every(this.fields, (f) => f.isValid() === true);
                                this.updateValidationStatus();
                            }
                        })
                    );
                });
            }

            this.$scope.$watch('vm.rootForm.$submitted', (v) => {
                if (v) {
                    this.active = true;
                    this.updateValidationStatus();
                }
            });
        }

        private blurHandler(e: any) :void {

            if (this.watchers.length && !this.alwaysWatch()) {
                _.each(this.watchers, w => w());
                this.watchers = [];
            }

            //use the elements name to get the field from the form
            let field = this.form[e.target.name];
            field.ValidationSummary.Focused = false;
            field.ValidationSummary.PreviouslyFocused = true;

            this.active = _.every(this.fields, (f) => f.wasPreviouslyFocused() === true);
            this.updateValidationStatus();
        }

        private focusHandler(e: any) :void {

            //use the elements name to get the field from the form
            let field = this.form[e.target.name];
            field.ValidationSummary.Focused = true;


            //if all the fields were previously active and we are invalid then watch our fields while we type
            //so that we know when we are valid
            if (_.every(this.fields, (f) => f.wasPreviouslyFocused() === true) && !this.alwaysWatch()) {
                _.each(this.fields, (f,i) => {
                    this.watchers.push(
                        this.$scope.$watch(`vm.fields[${i}].isValid()`, () => {
                                this.updateValidationStatus();
                            }, true
                        )
                    );
                });
            }
        }

        private updateValidationStatus() :void {
            let allValid = true;
            let errors :string[] = [];

            const errorClassName = 'sc-c-field--error';
            const successClassName = 'sc-c-field--success';
            const fds = this.fields;
            _.each(this.fields, (f, index) => {
                const valid = f.isValid();
                if (!valid && this.active) {
                    allValid = false;
                    _.forOwn(f.errorMessages(), (v, k) =>
                        errors.push(this.validationService.translateFieldLabel(this.labels[index], k, this.map))
                    );
                    const inputfields = f.getInputFields();
                    _.each(inputfields, field => {
                        field.parent().addClass(errorClassName);
                        if (field.parent().hasClass(successClassName)){
                            field.parent().removeClass(successClassName);
                        }
                    });
                } else if (valid && this.active) {
                    const inputfields = f.getInputFields();
                    _.each(f.getInputFields(), field => {
                        if (field.parent().hasClass(errorClassName)){
                            field.parent().removeClass(errorClassName);
                        }
                        field.parent().addClass(successClassName);
                    });
                }
            });

            this.$timeout(() => {
                this.invalid = !allValid;
                this.errorMessages = _.uniq(errors);
            }, 0);
        }

        private alwaysWatch() :boolean {
            return this.alwaysWatchFields === 'true';
        }

    }

    angular
        .module('TR')
        .directive('validationMessage', (): ng.IDirective => {
            return {
                require: '^form',
                restrict: 'E',
                replace: true,
                scope: {},
                template:
                    `<div>
                        <p class="sc-c-form-control-prompt sc-c-form-control-prompt--error"
                            ng-repeat="err in vm.errorMessages"
                            ng-show="vm.active && vm.invalid">
                            {{err}}
                        </p>
                    </div>`,
                bindToController: {
                    fieldNames: '@',
                    labelStrings: '@',
                    msgMap: '@?',
                    rootForm: '=',
                    waitFor: '=?',
                    alwaysWatchFields: '@?'
                },
                controller: ValidationMessage,
                controllerAs: 'vm',
                link: (scope :ValidationMessageScope,
                       el :ng.IAugmentedJQuery,
                       attr :ng.IAttributes,
                       formCtrl :ng.IFormController) => {

                    //there is an assumption here that the directive is within the same form as the input field
                    //we are validating and also that the field name is that same as the name property on the input.
                    // Not great, but so the we can keep everything together this might be ok (maybe, sort of)

                    //we need our form DOM element so that we can find the inputs
                    //get the elements parent forms and the first one should be the one to use
                    const formEl = ($(angular.element(el).parents('ng-form')[0])
                    || $(angular.element(el).closest('form.quoteFormNonReg')) );

                    if (attr.waitFor) {
                        const watch = scope.$watch('vm.waitFor', (v) => {
                            if (v) {
                                scope.vm.init(formCtrl, formEl);
                                watch();
                            }
                          });
                    } else {
                        scope.vm.init(formCtrl, formEl);
                    }
                }
            };
        });
}
